export default "__VITE_ASSET__Chc3p1rn__"